module.exports = __webpack_public_path__ + "img/otg.05cb4579.svg";